import { render, staticRenderFns } from "./ActivityAttributeEditor.vue?vue&type=template&id=3c8b26ce"
import script from "./ActivityAttributeEditor.vue?vue&type=script&lang=ts"
export * from "./ActivityAttributeEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports